import { createReducer } from 'reduxsauce'
import { configDuckList } from '~/store/config'

export const { 
  Connector, 
  Route, 
  Types, 
  Creators 
} = configDuckList("@Teams", { Connector: "News_1", Route: "teams_classification" });

const INITIAL_STATE = {
  loading: false,
  success: false,
  error: false,
  result: []
}

const getTeamsRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
  success: false
})

const getTeamsSuccess = (state = INITIAL_STATE, { data : {  result } }) => ({
  ...state,
  result,
  loading: false,
  success: true,
})

export default createReducer(INITIAL_STATE, {
  [Types.GET_REQUEST]: getTeamsRequest,
  [Types.GET_SUCCESS]: getTeamsSuccess,
})